export const BYTES_IN_MB = 1048576;

export const DEFAULT_FILES_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "mp3",
  "avi",
  "mpeg",
  "mov",
  "mp4",
  "webm",
];
